import http from '@/requests/http'

class Dashboard {
  static all (params) {
    return http.post('dashboard', params)
  }
}

export default Dashboard
